module.exports = __webpack_public_path__ + "img/ic_place_blue.35fa0401.svg";